import ContainerSimple from "../../../Components/ContainerSimple";
import InputAdmin from "../../../Components/InputFields/InputAdmin";
import Custom from "../../../Components/Buttons/Custom";
import MultipleSelectAdmin from "../../../Components/InputFields/MultipleSelectAdmin";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { API_BASE_URL } from "../../../config/api";

export default function NewEditPriceModal({
  onClose,
  initialPrice,
  initialDiscount,
  initialDiscountPercent,
}) {
  const { challengeId } = useParams();
  const [price, setPrice] = useState(initialPrice);
  const [discountPercent, setDiscountPercent] = useState(
    initialDiscountPercent,
  );
  const [priceAfterDiscount, setPriceAfterDiscount] = useState(initialDiscount);
  const handleUpdate = async () => {
    let jsonData = {};
    if (price) jsonData.cost = price;
    if (discountPercent) jsonData.discount_percent = discountPercent;
    if (priceAfterDiscount) jsonData.discount_cost = priceAfterDiscount;
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/discount/`,
        {
          method: "PATCH",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify(jsonData),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/discount/`,
          {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify(jsonData),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  const handleRemoveDiscount = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/discount/remove/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
          body: JSON.stringify({}),
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}/api/v0/auth/admin/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          window.location.href = "/signin";
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}/api/v0/challenges/admin/${challengeId}/discount/remove/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
            body: JSON.stringify({}),
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      onClose();
      window.location.reload();
    } catch (error) {
      console.error("Error fetching account data:", error);
    }
  };
  return (
    <ContainerSimple>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="قیمت چالش"
          id="price"
          name="price"
          type="number"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
        />
        <div className="w-full"></div>
      </div>
      <div className="w-full flex gap-12">
        <InputAdmin
          label="درصد تخفیف"
          id="discountPercent"
          name="discountPercent"
          type="number"
          value={discountPercent}
          onChange={(e) => setDiscountPercent(e.target.value)}
        />
        <InputAdmin
          label="قیمت پس از تخفیف"
          id="priceAfterDiscount"
          name="priceAfterDiscount"
          type="number"
          value={priceAfterDiscount}
          onChange={(e) => setPriceAfterDiscount(e.target.value)}
        />
      </div>
      {/* <div className="w-full flex gap-12">
        <InputAdmin label="زمان پایان تخفیف" id="endDiscountTime" name="endDiscountTime" type="datetime-local"/>
        <div className="w-full"></div>
      </div> */}
      <div className="flex gap-5 w-full">
        <Custom
          text="حذف تخفیف"
          svg_name="xMark"
          svgClassName="stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 text-zi-text-dark mt-6 bg-zi-gradient-button-blue w-full"
          textShadow={true}
          svgShadow={true}
          onClick={handleRemoveDiscount}
        />
        <Custom
          text="ویرایش قیمت و تخفیف"
          svg_name="pen"
          svgClassName="stroke-zi-text-dark"
          href=""
          className="!rounded-lg !p-2.5 text-zi-text-dark mt-6 bg-zi-gradient-button-blue w-full"
          textShadow={true}
          svgShadow={true}
          onClick={handleUpdate}
        />
      </div>
    </ContainerSimple>
  );
}
